module.exports = "/_next/static/images/916c3329a2d6fc0446ee6513f948c7fd-holding-card-vertical@1x.png";